module.exports = __webpack_public_path__ + "img/banker.56a2c67e.svg";